import { Fragment } from "react";
import CryptosSummary from "./CryptosSummary";
import AvailableCryptos from "./AvailableCryptos";

const Cryptos = (props) => {
  console.log("*** Cryptos ***")  
  console.log(props.cryptos);

  return (
    <Fragment>
      <CryptosSummary />
      <AvailableCryptos cryptos={props.cryptos} />
    </Fragment>
  );
};

export default Cryptos;